import React, {useState} from 'react'
import {useMediaQuery} from '@mui/material'
import {useDispatch, useSelector} from 'react-redux'
import {useFormik} from 'formik'
import * as yup from 'yup'
import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import CircularProgressAtom from '../../@atoms/to_forms/circular_progress/circular_progress.atom'
import DateSelectionActionBtnWrapperAtom from '../../@atoms/to_content/date_selection_action_btn_wrapper/date_selection_action_btn_wrapper.atom'
import ModalErrorAtom from '../../@atoms/to_content/modal_error/modal_error.atom'
import ModalHeaderAtom from '../../@atoms/to_layout/modal_header/modal_header.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import TextfieldAtom from '../../@atoms/to_forms/textfield/textfield.atom'
import useError from '../../@hooks/use_error'
import {RootState} from '../../store_redux'
import {fetchAllVisits} from '../../store_redux/reducer/order_details.reducer'
import {hideModal} from '../../store_redux/reducer/modal.reducer'
import VisitService, {
  UpdateInstructionPayload,
} from '../../services/visit.service'
import utils from '../../utils'
import useTextAreaHeight from '../../@hooks/use_textarea_height'
import useOnScreenKeyboardScrollFix from '../../@hooks/use_scroll_edit_instructions'
// eslint-disable-next-line func-names
const SpecialInstructionsComponent = function () {
  const [loading, setLoading] = useState(false)
  const rootState = useSelector((state: RootState) => state)
  const dispatch = useDispatch()
  const {labels, modal} = rootState
  const specialInstructionData = modal.data.specialInstruction
  const visitId = specialInstructionData.visitId || 0
  const {specialInstructionModal} = labels
  const showbackButton =
    useMediaQuery('(max-width:501px') &&
    specialInstructionData.redirectedFrom !== 'DATE_SCREEN'
  /* eslint-disable-next-line */
  // .required(specialInstructionModal.validationErrors.requiredConstraints)
  const validationSchema = yup.object().shape({
    specialInstruction: yup
      .string()
      .max(2000, specialInstructionModal.validationErrors.lengthConstraints)
      .matches(
        // eslint-disable-next-line
        /^([a-zA-Z0-9 .,:;*-\-\_\n]+)$/,
        specialInstructionModal.validationErrors.specialCharacters,
      )
      .strict(false)
      .trim(),
  })
  const {error, setError} = useError()
  const handleError = (err: Error) => {
    setError('updateSpecialInstruction', err.message)
    setLoading(false)
  }
  const formSubmit = (values: UpdateInstructionPayload) => {
    if (values.specialInstruction.includes('\n' || '\r'))
      values.specialInstruction = values.specialInstruction.replaceAll(
        '\n' || '\r',
        ' ',
      )
    values.specialInstruction = values.specialInstruction.trim()
    if (specialInstructionData.content.trim() === values.specialInstruction) {
      dispatch(hideModal())
      return
    }
    setLoading(true)
    const payload: UpdateInstructionPayload = values
    VisitService.updateSpecialInstructions(visitId, payload)
      .then(() => dispatch(fetchAllVisits()))
      .then(() => dispatch(hideModal()))
      .catch(handleError)
  }
  const formik = useFormik<UpdateInstructionPayload>({
    initialValues: {
      specialInstruction: specialInstructionData.content,
    },
    validationSchema,
    onSubmit: formSubmit,
  })
  const {handleSubmit, values, handleChange, errors} = formik
  const errorMessage = errors.specialInstruction
  const height = useTextAreaHeight(errorMessage)
  useOnScreenKeyboardScrollFix()
  const ModalBody = (
    <form onSubmit={handleSubmit}>
      <TypographyAtom ahd_type="step">
        {specialInstructionModal.description}
      </TypographyAtom>
      <TextfieldAtom
        placeholder={specialInstructionModal.placeholder}
        name="specialInstruction"
        value={values.specialInstruction}
        multiline
        fullWidth
        onChange={handleChange}
        error={!!errors.specialInstruction}
        helperText={errors.specialInstruction}
        inputProps={{style: {height: `${height}px`, overflow: 'auto'}}}
      />
      <DateSelectionActionBtnWrapperAtom
        className={utils.classnames({'cursor-not-allowed': loading})}
      >
        {specialInstructionData.redirectedFrom !== 'DATE_SCREEN' && (
          <ButtonAtom
            ap_type="secondary"
            className={utils.classnames({'btn-disabled': loading})}
            fullWidth
            onClick={() => dispatch(hideModal())}
          >
            Cancel
          </ButtonAtom>
        )}
        <ButtonAtom
          ap_type="primary"
          className={utils.classnames({'btn-disabled': loading})}
          fullWidth
          type="submit"
        >
          {loading ? (
            <CircularProgressAtom size="1.5rem" ap_type="btn_spinner" />
          ) : (
            specialInstructionModal.buttonFormSubmit
          )}
        </ButtonAtom>
      </DateSelectionActionBtnWrapperAtom>
    </form>
  )
  return (
    <>
      <ModalHeaderAtom showBackButton={showbackButton}>
        <TypographyAtom ahd_type="h6" textAlign="center">
          {specialInstructionData.type === 'EDIT'
            ? specialInstructionModal.titleForEdit
            : specialInstructionModal.titleForAdd}
        </TypographyAtom>
      </ModalHeaderAtom>
      {error.isError ? (
        <ModalErrorAtom
          errorMsg={error.errorMsg}
          btnLabel={specialInstructionModal.buttonForErrorClose}
        />
      ) : (
        ModalBody
      )}
    </>
  )
}
export default SpecialInstructionsComponent
